export default "__VITE_PUBLIC_ASSET__6c293090__"